module.exports = __webpack_public_path__ + "static/fonts/wd-icons.af7166d.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/wot-design/lib/theme-default/fonts/wd-icons.ttf
// module id = 230A
// module chunks = 1